import React from 'react';
import { Box, Typography, Breadcrumbs, Link, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { t } from '../../../../utils/textUtils';
import { useNavigate, useParams } from 'react-router-dom';

export default function Header({ projectName, loading }) {
  const navigate = useNavigate();
  const { projectId } = useParams();

  const handleBack = () => navigate(`/projects/${projectId}/detail`);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          {t('GANTT CHART HIERARKI')}
        </Typography>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}> 
          <Link 
            to="/projects"
            style={{ textDecoration: 'none', color: '#5D4037' }}
          >
            {t('PROYEK')}
          </Link>
          <Link 
            to={`/projects/${projectId}/detail`}
            style={{ textDecoration: 'none', color: '#5D4037' }}
          >
            {loading ? t('LOADING...') : projectName || t('DETAIL PROYEK')}
          </Link>
          <Typography color="text.primary">{t('GANTT CHART HIERARKI')}</Typography>
        </Breadcrumbs>
      </Box>
      <Button
        variant="outlined"
        color="warning"
        size="large"
        startIcon={<ArrowBackIcon fontSize="large" />}
        onClick={handleBack}
        sx={{
          padding: '15px !important',
          fontSize: '18px !important',
          fontWeight: 700,
          letterSpacing: 0.5,
          height: '45px',
          borderWidth: 2,
          borderColor: 'warning.main',
          color: 'warning.main',
          '&:hover': {
            borderWidth: 2,
            borderColor: 'warning.dark',
            backgroundColor: 'rgba(255, 152, 0, 0.06)',
          },
          borderRadius: 2,
        }}
      >
        {t('KEMBALI KE DETAIL PROYEK')}
      </Button>
    </Box>
  );
}
